export const RoleEnums = {"Anynonms":1, "Partener":2, "Admin":3}

